// extracted by css-extract-rspack-plugin
export default {"root":"i96FDtS_tgUrZLaK"};